import { ForwardedRef, forwardRef } from 'react';

import { Select } from '@xemplo/base-multi-select';
import { V2, V2Types } from '@xemplo/popover';
import { List } from '@xemplo/stateful-list';

import { useMultiSelect } from './hooks/use-multi-select';
import { TextDropdownMultiProps } from './text-dropdown-multi.types';

export const TextDropdownMulti = forwardRef(
  (props: TextDropdownMultiProps, ref?: ForwardedRef<HTMLDivElement>) => {
    const { popoverRef, selectProps, listProps } = useMultiSelect(props);

    return (
      <V2.Popover.Root
        ref={popoverRef}
        trigger={V2Types.PopoverTrigger.Click}
        onOpenChange={props.onOpenChange}
      >
        <V2.Popover.Trigger>
          {({ open }) => <Select {...selectProps} ref={ref} open={open} />}
        </V2.Popover.Trigger>
        <V2.Popover.Popup>
          <List.MultiSelect {...listProps} />
        </V2.Popover.Popup>
      </V2.Popover.Root>
    );
  }
);

export default TextDropdownMulti;
